import { GOOGLE_API_KEY } from "../../data/BaseUrl";

export const getGoogleMapsStaticUrl = (lat, lng) =>
  `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=16&size=500x220&markers=color:red%7C${lat},${lng}&key=${GOOGLE_API_KEY}`;

export const getGoogleMapsLink = (lat, lng) =>
  `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
